/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var AppHistoryEventType;
(function (AppHistoryEventType) {
    AppHistoryEventType["CREATED"] = "created";
    AppHistoryEventType["CONNECTED"] = "connected";
    AppHistoryEventType["SERVER_CONNECTED"] = "serverConnected";
    AppHistoryEventType["SERVER_DISCONNECTED"] = "serverDisconnected";
    AppHistoryEventType["STOPPED"] = "stopped";
    AppHistoryEventType["COMPLETED"] = "completed";
    AppHistoryEventType["SUPERVISION_REQUESTED"] = "supervisionRequested";
    AppHistoryEventType["SUPERVISION_RESPONDED"] = "supervisionResponded";
    AppHistoryEventType["ACTION_INVOKED"] = "actionInvoked";
    AppHistoryEventType["ACTION_FAILED"] = "actionFailed";
    AppHistoryEventType["DEPLOYMENT_FAILED"] = "deploymentFailed";
    AppHistoryEventType["RESOURCE_REQUESTED"] = "resourceRequested";
})(AppHistoryEventType || (AppHistoryEventType = {}));
